import { useState } from "react";
import axios from 'axios';

function DeleteAccount() {

    const [phone, setPhone] = useState("")
    const [isSubmitting, setIsSubmitting] = useState(false)


    const onSubmitForm = async (e) => {
        e.preventDefault()
        setIsSubmitting(true)

        if (phone.length === 0) alert("Please enter phone number")
        else if (phone.length < 12 || phone.length > 12) alert("Please enter a valid phone number")
        else {
            let data = JSON.stringify({
                "phone": phone
            });

            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: 'http://3.9.205.28:9000/auth/initiate_deletion',
                headers: {
                    'Content-Type': 'application/json',
                },
                data: data
            };

            axios.request(config)
                .then((response) => {
                    setIsSubmitting(false)
                    alert(response.data.message)
                    setPhone("")
                })
                .catch((error) => {
                    setIsSubmitting(false)
                });
        }
    };
    return (
        <div className="flex justify-center">
            <div className="w-full ">
                <div className="py-6">
                    <div className="container">
                        <h1 className="p-10 text-4xl font-bold text-center">
                            Account deletion
                        </h1>
                    </div>
                    <form onSubmit={onSubmitForm}>
                        <div className="max-w-2xl mx-auto mt-6 bg-white shadow-sm">
                            <p className="mb-2 font-medium ps-2">Phone Number</p>
                            <input

                                type="phone"
                                className="w-full p-2 border"
                                placeholder="2567000000909"
                                value={phone}
                                onChange={(e) => setPhone(e.target.value)}
                            />
                            <button
                                className="w-full p-3 mt-3 text-white rounded-md main-bg"
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? "Loading..." : "Delete Account"}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default DeleteAccount
